import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="text-2xl font-bold mb-4">
              <span className="text-yellow-400">Nutri</span>
              <span className="text-white">Bot</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('home.footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('home.footer.product.title')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.product.features')}
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.product.pricing')}
                </a>
              </li>
              <li>
                <Link to="/dashboard" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.product.dashboard')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('home.footer.company.title')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.company.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.company.contact')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.company.privacy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* <div>
            <h3 className="text-white font-semibold mb-4">{t('home.footer.support.title')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.support.help')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm cursor-pointer">
                  {t('home.footer.support.faq')}
                </a>
              </li>
            </ul>
          </div> */}
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">{t('home.footer.copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
